import { render, staticRenderFns } from "./UnitCodeItem.vue?vue&type=template&id=f0a4f35e"
import script from "./UnitCodeItem.vue?vue&type=script&lang=js"
export * from "./UnitCodeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0a4f35e')) {
      api.createRecord('f0a4f35e', component.options)
    } else {
      api.reload('f0a4f35e', component.options)
    }
    module.hot.accept("./UnitCodeItem.vue?vue&type=template&id=f0a4f35e", function () {
      api.rerender('f0a4f35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/UnitCodeItem.vue"
export default component.exports